/* eslint-disable no-console */

import { register } from 'register-service-worker';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import AppStoreModule from './store/modules/AppStoreModule';

let serviceWorkerRegistered = false;

export default function registerServiceWorker(): void {
	if (serviceWorkerRegistered) return;
	// Set slide transform function from outside the store to avoid cycle dependencies when transforms using the store
	const appStore: AppStoreModule = getStoreModule(AppStoreModule);

	if (!!navigator.serviceWorker && process.env.NODE_ENV === 'production') {
		register(`${process.env.BASE_URL}service-worker.js`, {
			ready(): void {
				console.log('[service-worker] App is being served from cache by a service worker.');
			},
			registered(): void {
				serviceWorkerRegistered = true;
				console.log('[service-worker] Service worker has been registered.');
			},
			cached(): void {
				console.log('[service-worker] Content has been cached for offline use.');
			},
			updatefound(): void {
				console.log('[service-worker] App is downloading.');
			},
			updated(): void {
				console.log('[service-worker] New App version is available: refresh required.');
				appStore.setIsApplicationReadyToBeUpdated(true);
			},
			offline(): void {
				// handle online state initially before anything is being fetched by the app, e.g. via globals store module
				appStore.setIsOnline(false);
				console.log('[service-worker] No internet connection found. App is running in offline mode.');
			},
			error(error: Error): void {
				console.error('[service-worker] Error during service worker registration:', error);
			}
		});

		navigator.serviceWorker.addEventListener('controllerchange', (): void => {
			appStore.setIsApplicationReadyToBeUpdated(true);
		});
	}
}
/* eslint-enable no-console */
